import React, { ReactElement, ReactNode } from "react";

interface Props {
	children: ReactNode;
	className?: string;
}

const Paragraph1 = ({ children, className }: Props): ReactElement => {
	return <p className={"font-sen text-xs font-normal " + className}>{children}</p>;
};

export default Paragraph1;
